import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { PlantService, ProgramService, PlantProgramService, GlobalRegionService } from '../../../mesc.service';
import { PlantProgram } from '../../../../../shared/model';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { MaintenanceService } from "../maintenance.service";

@Component({
    selector: 'app-plant-program',
    templateUrl: './plant-program.component.html',
    // styleUrls: ['./plant-program.component.scss']
})
export class PlantProgramComponent implements OnInit {
    // @ViewChild('combo') public combo: ComboBoxComponent;
    private readonly maintenanceService: MaintenanceService;

    @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
    EditGlobalRegion = {};

    GlobalRegions: PlantProgram[] = [];
    SelectedGlobalRegion: any = undefined;

    isNew: boolean = false;
    editDataItem: PlantProgram;

    editForm = new FormGroup({

        PlantId: new FormControl("", Validators.required),
        ProgramId: new FormControl("", Validators.required),
        PlantProgramDescription: new FormControl(),
        GlobalRegionName: new FormControl(),
        GlobalRegionId: new FormControl(),
        IsActive: new FormControl(false, Validators.required),
        Id: new FormControl(),
        CreatedDate: new FormControl(),
        CreatedBy: new FormControl(),
        ModifiedDate: new FormControl(),
        ModifiedBy: new FormControl(),


    });


    columns: any[] = [

        {
            field: 'PlantName',
            title: 'Plant',
        },
        {
            field: 'ProgramDescription',
            title: 'Program'
        },
        {
            field: "IsActive",
            title: "Status",
            width: 125,
            template: {
                type: "boolean",
                onLabel: "Active",
                offLabel: "Inactive"
            }
        }];


    constructor(
        public plantProgramService: PlantProgramService,
        public plantService: PlantService,
        public programService: ProgramService,
        private cgpSnackbarService: CgpSnackbarService,
        private cgpAlertDialogService: CgpAlertDialogService,
        // public RegionService: RegionService,
        public globalRegionService: GlobalRegionService,
        injector: Injector,

    ) {
        this.maintenanceService = injector.get(MaintenanceService);
        this.maintenanceService.getCurrentPageValue();
    }

    ngOnInit(): void {
        this.globalRegionService.subscribe(x => this.GlobalRegions = x);
        this.globalRegionService.query();
        this.refreshPrograms();
    }

    // You do this both for Plant and Program //

    setModelHandler() {
        let plant = new PlantProgram();
        plant['GlobalRegionName'] = this.SelectedGlobalRegion.Description
        plant['GlobalRegionId'] = this.SelectedGlobalRegion.Id
        this.editDataItem = plant;


        let Program = new PlantProgram();
        Program['GlobalRegionName'] = this.SelectedGlobalRegion.Description
        Program['GlobalRegionId'] = this.SelectedGlobalRegion.Id
        this.editDataItem = Program;

        this.editDataItem.IsActive = true;
    }

    //This is a Odata filter through the Services //
    //What it does is it passses your selected global region Id and attaches it to the end of the plantservice. This allows you to see only those plants that are in that global region even tho Plant Controller does not have a Get by GlobalRegion call //

    handleValueChange(e: any) {
        this.SelectedGlobalRegion = e;
        if (!e) return;
        this.refreshPlants();
        this.refreshPrograms()
    }

    handleFilter(value: any) {
        this.GlobalRegions = this.globalRegionService.data
            .filter((s) => {
                return s.Description.toLowerCase()
                    .indexOf(value.toLowerCase()) !== -1;
            })
    }

    onEdit(object) {
        object.dataItem.GlobalRegionName = this.SelectedGlobalRegion.Description;
        // To debug we looked @ the common.pipe.ts file //
    }



    handleread = () => {
        return this.SelectedGlobalRegion ?
            this.plantProgramService.read('/globalregion/' + this.SelectedGlobalRegion.Id, true).then(function (response) {
                response.map(x => {
                    x.PlantName = x.PlantCode ? x.PlantCode : x.PlantDescription;
                });
                return response;
            }) : Promise.resolve([]);

    }


    handleControlDisabled = (controlName: string) => {
        let isDisabled: boolean = false;
        switch (controlName) {
            case 'excel':
            case 'add':
                isDisabled = this.SelectedGlobalRegion === undefined;
                break;
            default:
                break;
        }
        return isDisabled;
    }

    onSave = (dataItem, isNew) => {
        var self = this;
        self.plantProgramService.save(dataItem, isNew, "", true, false)
            .then(function () {
                self.grid.refresh(true);
                self.cgpSnackbarService.showSnackbar({
                    message: isNew ? "Record has been created" : "Record has been updated",
                    duration: 2000
                });
            }).catch(function (response) {
                self.plantProgramService.loading.next(false);
                self.cgpAlertDialogService.showAlertDialog({
                    title: 'Error',
                    message: response._body.replace(/"/g, ''),
                    alert: 'danger',
                    closeLabel: 'Close',
                })
            })
    }

    template = {
        controls: {
            add: true,
            edit: true,
            delete: false,
            excel: true,
            isDisabled: this.handleControlDisabled,
            width: 65
        },
        columns: this.columns,
        view: this.globalRegionService,
        service: this.plantProgramService,
        fileName: 'plants_programs.xlsx',
        read: this.handleread,
        save: this.onSave,
    }

    formDialog = {
        title: "Plant-Program Association",
        formControls: [
            {
                type: "value",
                name: "GlobalRegionName",
                title: "Global Region",
                data: this.GlobalRegions,
                readonly: "update",
            },
            {
                type: "combobox",
                //  readonly: "never",
                name: "PlantId",
                title: "Plant*",
                textField: 'PlantName',
                valueField: 'Id',
                placeholder: 'Select a Plant...',
                service: this.plantService,
            },
            {
                type: "combobox",
                //  readonly: "never",
                name: "ProgramId",
                title: "Program*",
                textField: 'ProgramName',
                valueField: 'Id',
                width: 385,
                placeholder: 'Select a Program...',
                service: this.programService,
            },
            {
                type: "boolean",
                name: "IsActive",
                title: "Active",
            }
        ],
    }

    /**
     * Enhancement - Update dropdown description
     * TFS Task Id: 
     * 10/14/2020
     */
    private refreshPlants() {
        this.plantService.read('?$filter=GlobalRegionId eq ' + this.SelectedGlobalRegion.Id)
            .then(result => {
                result.map(p => {
                    p.PlantName = `[${p.PlantCode || null}] ${p.PlantDescription}`;
                    return p;
                });
                return result;
            });
    }

    /**
     * Enhancement - Update dropdown description
     * TFS Task Id:
     * 10/14/2020
     */
    private refreshPrograms() {
        const queryString = this.SelectedGlobalRegion ? `?$filter=GlobalRegionId eq ${this.SelectedGlobalRegion.Id}` : '';
        this.programService.read(queryString)
            .then(x => {
                return x.map(p => {
                    const attrs = [p.ProgramCode || null, p.ProgramModelYear || null, p.ProgramStyle || null]
                        .join(' | ');
                    p.ProgramName = `[${attrs}] ${p.ProgramDescription}`;
                    return p;
                });
            });
    }

}
